import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Ant Design v5

// Optional: basic app styles (if file exists, it will be used; if not, harmless)
// import './styles.css';

function setupTelegramWebApp() {
  try {
    const tg = window.Telegram?.WebApp;
    if (!tg) return;

    // Ensure the webapp is ready and expanded
    tg.ready();
    tg.expand();

    // Use Telegram theme colors where possible
    const root = document.documentElement;
    if (tg.themeParams?.bg_color) root.style.setProperty('--tg-bg', tg.themeParams.bg_color);
    if (tg.themeParams?.text_color) root.style.setProperty('--tg-text', tg.themeParams.text_color);
  } catch (_) {}
}

setupTelegramWebApp();

const el = document.getElementById('root');
if (!el) {
  throw new Error('Root element #root not found');
}

createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
